<template>
    <v-app v-if="!isLocalStorageAvailable">
        <p>Váš prohlížeč není podporován. Proveďte aktualizaci.</p>
    </v-app>
    <v-app v-else-if="loading">
        <v-progress-linear :indeterminate="true"/>
    </v-app>
    <v-app v-else :class="pageClasses">
        <div class="headermenu">
            <v-navigation-drawer
                v-model="drawer"
                fixed
                flat
                app
                :temporary="!isLoggedIn"
                :right="!isLoggedIn"
                :permanent="isLoggedIn && this.$vuetify.breakpoint.mdAndUp"
            >
                <div class="logotablet">
                    <img src="/img/Symbol-Staropramen.svg">
                </div>
                <v-list dense>
                    <v-list-item
                        v-for="menuItem in mainMenu"
                        :key="menuItem.link + menuItem.hash"
                        :to="{ name: menuItem.link, hash: menuItem.hash }"
                        exact>
                        <v-list-item-action>
                            <v-icon>{{ menuItem.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
            <v-app-bar color="primary" fixed flat>
                <v-toolbar-title>
                    <router-link to="/" tag="span" style="cursor: pointer">
                        <img src="/img/logo/Symbol-Staropramen.svg" class="logo" width="200px" height="130px">
                    </router-link>
                </v-toolbar-title>

                <v-spacer/>
                <v-toolbar-title v-if="isLoggedIn" class="orange--text pr-2 d-none d-sm-block nickname">
                    {{ user.nickname }}
                </v-toolbar-title>
                <v-toolbar-items v-if="isLoggedIn">
                    <v-btn @click.prevent="userLogOut" class="logout" :loading="logOutLoading" text>Odhlásit</v-btn>
                </v-toolbar-items>
                <v-toolbar-items class="hidden-sm-and-down" :class="{ 'd-none': isLoggedIn }">
                    <v-btn
                        v-for="menuItem in mainMenu"
                        :key="menuItem.link + menuItem.hash"
                        :to="{ name: menuItem.link, hash: menuItem.hash }"
                        text
                        class="menuitem"
                    >
                        {{ menuItem.title }}
                    </v-btn>
                </v-toolbar-items>
                <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"/>
            </v-app-bar>
        </div>
        <v-content fill-height fill-width class="main-content">
            <router-view/>
            <footer-menu />
        </v-content>
        <div>
            <v-footer inset app absolute>
                <v-container>
                    <v-row>
                        <v-col cols="14" offset="1">
                            <v-row>
                                <v-col cols="16" sm="8">
                                    <p class="centerxs">&copy;&nbsp;Pivovary&nbsp;Staropramen&nbsp;s.r.o., Provozovatel:&nbsp;<router-link tag="span" :to="{ name: 'contact' }" style="cursor: pointer"><u>Cool&nbsp;Ticketing&nbsp;s.r.o.</u></router-link></p>
                                </v-col>
                                <v-col cols="16" sm="8" class="rightcenter">
                                    <router-link :to="{ name: 'rules' }" tag="span" style="cursor: pointer">
                                        <u>Pravidla soutěže</u>
                                    </router-link>
                                    <router-link :to="{ name: 'gdpr' }" tag="span" style="cursor: pointer">
                                        <u>Ochrana osobních údajů</u>
                                    </router-link>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-footer>
        </div>
        <age-dialog/>
    </v-app>
</template>

<script>
    import { mapState } from 'vuex'
    import { INFO_REQUEST, LOGOUT_REQUEST } from './store/actions/user'
    import { storageAvailable } from './plugins/utils'
    import AgeDialog from './components/Common/AgeDialog';
    import FooterMenu from './components/Graphics/FooterMenu.vue'

    export default {
        name: 'App',
        components: {
            AgeDialog,
            FooterMenu,
        },
        data () {
            return {
                drawer: false,
                logOutLoading: false,
                loading: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
            pageClasses () {
                let classes = this.$route.meta.pageClasses ? this.$route.meta.pageClasses : '';
                if (this.isLoggedIn) {
                    classes += ' isLoggedIn';
                }
                return classes;
            },
            mainMenu () {
                let menu = [];

                if (this.isLoggedIn) {
                    menu.push(...[
                        { icon: 'mdi-home', title: 'Přehled', link: 'dashboard', hash: '' },
                        { icon: 'mdi-trophy', title: 'Turnaje', link: 'tournament', hash: '' },
                        { icon: 'mdi-forum', title: 'Zprávy', link: 'messages', hash: '' },
                        { icon: 'mdi-account', title: 'Můj profil', link: 'userSettings', hash: '' },
                        { icon: 'mdi-account-supervisor', title: 'Můj tým', link: 'myTeam', hash: '' },
                        { icon: 'mdi-account-supervisor', title: 'Přehled týmů', link: 'teams', hash: '' },
                        { icon: 'mdi-account', title: 'Přehled hráčů', link: 'users', hash: '' },
                    ]);
                } else {
                    menu.push(...[
                        { icon: 'mdi-login', title: 'Výhry', link: 'home', hash: '#o-co-hrajeme' },
                        { icon: 'mdi-lock-question', title: 'Jak začít', link: 'home', hash: '#jak-zacit' },
                        { icon: 'mdi-home', title: 'Pravidla', link: 'home', hash: '#pravidla' },
                        { icon: 'mdi-lock-question', title: 'Mapa hospod', link: 'home', hash: '#mapa-hospod' },
                        { icon: 'mdi-login', title: 'Přihlásit', link: 'signIn', hash: '' },
                        { icon: 'mdi-account-plus', title: 'Registrace', link: 'registration', hash: '' },
                    ]);
                }

                return menu;
            },
            isLoggedIn () {
                return this.$store.getters['user/isLoggedIn'];
            },
            isLocalStorageAvailable () {
                return storageAvailable('localStorage');
            },
        },
        methods: {
            async userLogOut () {
                try {
                    this.logOutLoading = true;
                    await this.$store.dispatch('user/' + LOGOUT_REQUEST);
                    this.$toast.success('Odhlášení bylo úspěšné.');
                    await this.$router.push({ name: 'signIn' });
                } catch (e) {
                    this.$toast.success('Při odhlašování došlo k chybě.');
                } finally {
                    this.logOutLoading = false;
                }
            },
        },
        watch: {
            async isLoggedIn (val, oldVal) {
                if (oldVal === false && val !== false) {
                    try {
                        const backlink = localStorage.getItem('login-backlink');
                        await this.$router.push(JSON.parse(backlink)).catch(e => {});
                        localStorage.removeItem('login-backlink');
                    } catch (e) {
                        await this.$router.push({ name: 'dashboard' }).catch(e => {});
                    }
                    this.$toast.success('Vítejte zpět.');
                }
            },
        },
        async created () {
            try {
                this.loading = true;
                await this.$store.dispatch('user/' + INFO_REQUEST);
            } finally {
                this.loading = false;
            }
        },
    }
</script>
